import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import MarketAdjustmentLedgerContext from 'pages/Valuations/approaches/backsolveApproach/MarketAdjustmentLedger/util/MarketAdjustmentLedgerContext';
import { getSelectionCellOptions } from 'pages/ValuationsAllocation/util/getSelectionCellOptions';
import { MarketAdjustmentGridSelectProps } from './MarketAdjustmentGridSelect.props';

const MarketAdjustmentGridSelect = (props: MarketAdjustmentGridSelectProps) => {
  const { cellOptions } = useContext(MarketAdjustmentLedgerContext);
  const optionsData = isEmpty(cellOptions)
    ? (props.cell.sheet?.tableData as any).approach.valuations_approach_backsolve
    : cellOptions;
  const options = getSelectionCellOptions({
    specificApproach: optionsData,
  });
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: GridSelect is not typed
  return <GridSelect menuPosition="fixed" options={options} enumerated {...props} />;
};

export default MarketAdjustmentGridSelect;
